import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Auth Token Interceptor
 *
 * Automatically adds a Bearer token to the Authorization header of every outgoing HTTP request.
 * Retrieves the token from localStorage using the key 'authToken'.
 * Skips adding the header if no token is available.
 *
 * Execution order: Second (runs after API URL interceptor, before error interceptor)
 *
 * Token storage:
 * - The token is expected to be stored in localStorage with key 'authToken'
 * - To set the token: localStorage.setItem('authToken', 'your-token-here')
 * - To remove the token: localStorage.removeItem('authToken')
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
    const apiKey = '04577BA6-3E32-456C-B528-E41E20D28D79';

    // Clone the request and add the Authorization header with API key
    const modifiedReq = req.clone({
        setHeaders: {
            Authorization: apiKey
        }
    });

    return next(modifiedReq);
};;
